/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Profile from "../Profile";
import { dateToViewFormatWithDayNameWithTime } from "../../utils/date";
import FileInfo from "../File/FileInfo";
import Icon from "../Icon";
import XIcon from "../../assets/images/icon/x-icon.svg";
import systemAlert from "../../utils/systemAlert";
import { deleteComent } from "../../apis/comment";
import { each, isNull } from "lodash";
import Button from "../Button";
import DownloadIcon from "../../assets/images/icon/download-icon.svg";
import { download } from "../../utils/download";
import CommentReaction from "./CommentReaction";

const CommentItem = ({
  comment = {},
  submit,
  isReadCheck,
  employee
}) => {
  const [isNew, setIsNew] = useState(false);

  useEffect(() => {
    if (employee && isReadCheck && employee.idx !== comment.writerEmpIdx && isNull(comment.viewEmployee)) {
      setIsNew(!comment?.isRead);
    }
  }, [isReadCheck, employee]);

  const downloadAll = () => {
    each(comment?.uploadFiles, (file) => {
      const fileName = file.originalName || file.name;
      const fileUrl = file.fileUrl;
      download(fileUrl, fileName);
    });
  };

  console.log();


  return (
    comment &&
    <div className={'comment-item'}>
      <div className={'comment-info mb-5'}>
        <Profile data={comment.employee} />
        <span className={`comment-create-time`}>
          {dateToViewFormatWithDayNameWithTime(comment.createdTime)}
        </span>

        <div className="comment-all-btn-wrap">
          {comment?.uploadFiles?.length > 1 && (
            <>
              <Button
                onClick={downloadAll}
                size="x-sm"
                color="gray-line"
                className="download-all-button print-out"

              >
                전체 다운로드 <Icon src={DownloadIcon} />
              </Button>
            </>
          )}
        </div>

      </div>
      <div className={'comment-contents'}>
        <div className={`comment-content${isNew ? " font-bold" : ""}`}>
          {comment.content}
          {isNew ?
            <small className="color-red-100 font-size-10 ml-2 display-inline">new</small>
            : !isNull(comment?.viewEmployee) && (
              <div className="comment-info comment-view-info">
                <div className="vertical-line" />
                <Profile data={comment.viewEmployee} />
                <span className={`comment-create-time`}>
                  {dateToViewFormatWithDayNameWithTime(comment.viewTime)}
                </span>
              </div>
            )
          }
        </div>
        <div className={'comment-files'}>
          {comment.uploadFiles && comment.uploadFiles.map((file, idx) =>
            <FileInfo files={comment.uploadFiles} selected={idx} isDownload={true} file={file} key={idx}></FileInfo>
          )}
        </div>
        <div className="comment-reaction">
          <CommentReaction commentIdx={comment.idx} />
        </div>
      </div>
      
      <div className="comment-button-wrap print-out">
        <Icon
          src={XIcon}
          className={"delete-icon"}
          onClick={() => {
            systemAlert('해당 코멘트를 삭제하시겠습니까?', {
              buttons: [
                {
                  color: 'text',
                  label: '취소'
                },
                {
                  label: '확인',
                  onClick: () => {
                    deleteComent(comment.idx).then(() => {
                      submit();
                    });
                  }
                }
              ]
            });
          }}
        />
      </div>


    </div>
  );
};
export default CommentItem;
